import { AxiosResponse } from "axios";
import axios from "./config";
import {
  DeleteLocalizedSectionApiResponse,
  GetAllergicSectionsApiResponse,
  GetAllergiesApiResponse,
  GetAssignedRawMaterialsApiResponse,
  GetLocalizedAllergicSectionApiResponse,
  GetRawMAterialsApiResponse,
  PostAllergicItemApiResponse,
  PostAllergicSectionPayload,
  PostAllergicSectionsApiResponse,
  PostAllergyItemPayload,
  PostAssignRawMaterialApiResponse,
  PostAssignRawMaterialPayload,
  PostLocalizedAllergySectionApiResponse,
  PostLocalizedAllergySectionPayload,
} from "app/types/allergies";

export const getAllergicSectionsApi = (
  query?: string
): Promise<AxiosResponse<GetAllergicSectionsApiResponse>> =>
  axios.get<GetAllergicSectionsApiResponse>(
    `/allergic-sections${query ? query : ""}`
  );

export const postAllergicSectionsApi = (
  payload: PostAllergicSectionPayload
): Promise<AxiosResponse<PostAllergicSectionsApiResponse>> =>
  axios.post<PostAllergicSectionsApiResponse>(`/allergic-sections`, payload);

export const putAllergicSectionsApi = (
  id: number,
  payload: PostAllergicSectionPayload
): Promise<AxiosResponse<PostAllergicSectionsApiResponse>> =>
  axios.put<PostAllergicSectionsApiResponse>(
    `/allergic-sections/${id}`,
    payload
  );

export const getAllergiesApi = (
  query?: string
): Promise<AxiosResponse<GetAllergiesApiResponse>> =>
  axios.get<GetAllergiesApiResponse>(
    `/allergic-items-all${query ? query : ""}`
  );

export const postAllergiesApi = (
  payload: PostAllergyItemPayload
): Promise<AxiosResponse<PostAllergicItemApiResponse>> =>
  axios.post<PostAllergicItemApiResponse>(`/allergic-items`, payload);

export const putAllergiesApi = (
  id: number,
  payload: PostAllergyItemPayload
): Promise<AxiosResponse<PostAllergicItemApiResponse>> =>
  axios.put<PostAllergicItemApiResponse>(`/allergic-items/${id}`, payload);

export const getLocalizedSectionsApi = (
  sectionId: number,
  query?: string
): Promise<AxiosResponse<GetLocalizedAllergicSectionApiResponse>> =>
  axios.get<GetLocalizedAllergicSectionApiResponse>(
    `/allergic-sections/${sectionId}/localizations${query ? query : ""}`
  );

export const postLocalizedAllergySectionApi = (
  id: number,
  payload: PostLocalizedAllergySectionPayload
): Promise<AxiosResponse<PostLocalizedAllergySectionApiResponse>> =>
  axios.post<PostLocalizedAllergySectionApiResponse>(
    `/allergic-sections/${id}/localizations`,
    payload
  );

export const deleteLocalizedAllergySectionApi = (
  id: number,
  query?: string
): Promise<AxiosResponse<DeleteLocalizedSectionApiResponse>> =>
  axios.delete<DeleteLocalizedSectionApiResponse>(
    `/allergic-sections/${id}/localizations${query ? query : ""}`
  );

export const getLocalizedAllergyItemApi = (
  id: number,
  query?: string
): Promise<AxiosResponse<GetLocalizedAllergicSectionApiResponse>> =>
  axios.get<GetLocalizedAllergicSectionApiResponse>(
    `/allergic-items/${id}/localizations${query ? query : ""}`
  );

export const postLocalizedAllergyItemApi = (
  id: number,
  payload: PostLocalizedAllergySectionPayload
): Promise<AxiosResponse<PostLocalizedAllergySectionApiResponse>> =>
  axios.post<PostLocalizedAllergySectionApiResponse>(
    `/allergic-items/${id}/localizations`,
    payload
  );

export const deleteLocalizedAllergyItemApi = (
  id: number,
  query?: string
): Promise<AxiosResponse<DeleteLocalizedSectionApiResponse>> =>
  axios.delete<DeleteLocalizedSectionApiResponse>(
    `/allergic-items/${id}/localizations${query ? query : ""}`
  );

export const getRawMaterialsApi = (
  query?: string
): Promise<AxiosResponse<GetRawMAterialsApiResponse>> =>
  axios.get<GetRawMAterialsApiResponse>(`/items${query ? query : ""}`);

  export const getRawMaterialsByStoreIdApi = (
    storeId: number,
    query?: string
  ): Promise<AxiosResponse<GetRawMAterialsApiResponse>> =>
    axios.get<GetRawMAterialsApiResponse>(`/stores/${storeId}/items${query ? query : ""}`);

    
export const getAssignedRawMaterials = (
  id: number
): Promise<AxiosResponse<GetAssignedRawMaterialsApiResponse>> =>
  axios.get<GetAssignedRawMaterialsApiResponse>(`/allergic-items/${id}/items`);

export const postAssignRawMaterialsApi = (
  id: number,
  payload: PostAssignRawMaterialPayload
): Promise<AxiosResponse<PostAssignRawMaterialApiResponse>> =>
  axios.post<PostAssignRawMaterialApiResponse>(
    `/allergic-items/${id}/items`,
    payload
  );
